@if (review) {
  <section class="w-full shadow-md md:shadow-none print:h-fit print:shadow-none">
    @if (!isPrintMode && !isReportOwner && review.trixelImgUrl) {
      <rma-trixel [trixelImgUrl]="review.trixelImgUrl" />
    }
    <section class="w-full break-inside-avoid px-4">
      <div class="mb-4 flex w-full print:table">
        <span class="relative mr-4 hidden w-56 flex-initial shrink-0 align-middle md:block print:mr-0 print:table-cell print:pr-4">
          <rma-carousel class="aspect-[1.5] max-w-full rounded" [source]="images" />
        </span>
        <div class="inline-block print:table-cell">
          <p class="mb-2">{{ review.fullAddress }}</p>
          <rma-property-attribute
            class="mb-2 text-steel-70"
            [carparks]="review.carparks"
            [bathrooms]="review.bathrooms"
            [bedrooms]="review.bedrooms"
            [propertyType]="review.propertyType"
          />
          @if (review.starRating) {
            <rma-star-rating class="mb-2" [overallStars]="review.starRating" />
          }
          <div>{{ reviewerTypeKey | transloco }} {{ 'review-status.recommended' | transloco | lowercase }}</div>
        </div>
      </div>
      <div class="hidden md:block print:block print:pt-2">
        <ng-container *ngTemplateOutlet="reviewContent" />
      </div>
      <div class="see-more md:hidden print:hidden">
        <rma-see-more-text class="flex-auto">
          <ng-container *ngTemplateOutlet="reviewContent" />
        </rma-see-more-text>
      </div>
    </section>
    <ng-template #reviewContent>
      <h3 class="mat-body-1 mb-2" [innerHTML]="review.title"></h3>
      <p class="mb-6" [innerHTML]="review.description"></p>
      <p class="mat-caption text-steel-70">by {{ review.reviewerType | lowercase }} {{ review.reviewedOn | timeAgo }}</p>
    </ng-template>
  </section>
}
